import { useModalStore } from './store';

export { useModal, useModalComponent } from './useModal';
export { default as ModalContainer } from './components/ModalContainer.vue';

export const modals = {
  install() {
    useModalStore();
  },
};
